<div class="cell auto" *ngIf="parameters">
    <kiwi-parameters-tab-content-header
        [saveDisabled]="areParametersReadonly()"
        (saved)="updateParameters()"
        [titleLabelKey]="'parameters.standing.communication.title'">
    </kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.standing.communication.description'"></p>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'parameters.standing.communication.axes.axis.name'"></th>
            <th [i18nKey]="'parameters.standing.communication.axes.axis.standing'"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let axis of parameters.communicationAxes | keyvalue">
            <td>
                {{'axis.' + axis.key | translate}}
            </td>
            <td>
                {{axis.value}}
            </td>
        </tr>
        </tbody>
    </table>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th>
            </th>
            <th [i18nKey]="'parameters.standing.communication.axes.axis.weight'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.standing.communication.axes.first.axis'"></td>
            <td>
                {{parameters.mainCommunicationAxisWeight}}
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.standing.communication.axes.second.axis'"></td>
            <td>
                {{parameters.secondaryCommunicationAxisWeight}}
            </td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <table class="_tableColor">
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.standing.communication.standard.advertisement.budget'"></td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.standardAdvertisementBudget"
                                     [disabled]="areParametersReadonly()"></kiwi-currency-input>
            </td>
        </tr>
        </tbody>
    </table>
</div>
